import InvoicesPage from "@/tests/pages/InvoicesPage";

class InvoiceDetailsPage {
    public elements = {
        header: () => cy.get('.athenaeum-page-container-header'),
        statusInfo: () => cy.get("#statusInfo"),
        approve: () => cy.get("#approveInvoice"),
        decline: () => cy.get("#declineInvoice"),
        confirmationDialog: () => cy.get("div.athenaeum-confirmation-dialog-opened"),
        additionalExpense: (index: number) => cy.get(`#additionalExpenseInvoiced_${index}`),
        rows: () => cy.get('@rows'),
        invoiceOtherResources: () => cy.get('#invoiceOtherResourcesCheckbox'),
        expenseDdl: () => cy.get(`#expenses`),
        expenseElement: (expenseId: string) => cy.get(`#expense_${expenseId}`),
        expenseElementShouldInvoice: (expenseId: string) => cy.get(`#shouldInvoice_${expenseId}`),
        expenseElementAmount: (expenseId: string) => cy.get(`#setExpenseAmount_${expenseId}`),
        expenseElementTypes: (expenseId: string) => cy.get(`#expenseTypes_${expenseId}`),
    };

    public routes = {
    };
}

export default new InvoiceDetailsPage();